// Fallback course for public (unauthenticated) pages when the course catalog
// cannot be fetched from the API. Built only from session data so public
// pages degrade gracefully without inventing catalog content.
import type { PBSession } from '../api/sessionsService'
import type { Course } from '../stores/types'

export function buildFallbackCourse(session: PBSession): Course {
  return {
    id: session.courseId,
    name: session.courseName ?? session.courseId,
    slug: session.courseSlug ?? session.courseId,
    description: '',
    type: 'presencial',
    validYears: 1,
    isActive: true,
    order: 0,
    quizConfig: { passingScore: 0, questions: [] },
  }
}
